import { Flag } from '@fullstory/proto/fs/shared/flags';
import { useFlags } from '@fullstory/react-hooks';
import { useMemo } from 'react';

export const useSpacesEnabled = () => {
  const flags = useFlags();

  return useMemo(
    () => ({
      hasSpacesFeaturePack: flags.hasBit(Flag.FeatSpaces),
    }),
    [flags],
  );
};
